// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-editor-container[data-v-a361ec26] {\n  padding: 15px;\n  background-color: #f0f2f5;\n  position: relative;\n}\n.dashboard-editor-container .github-corner[data-v-a361ec26] {\n  position: absolute;\n  top: 0px;\n  border: 0;\n  right: 0;\n}\n.dashboard-editor-container .chart-wrapper[data-v-a361ec26] {\n  background: #fff;\n  padding: 16px 16px 0;\n}\n@media (max-width: 1024px) {\n.chart-wrapper[data-v-a361ec26] {\n    padding: 8px;\n}\n}", ""]);
// Exports
module.exports = exports;
